import { Box, FieldSet, Label, LabeledControl, Legend, Radio, Text } from '@zillow/constellation-10';
import { EXTERNAL_WIZARD_OPTIONS, WIZARD_SCREEN_TYPES } from '../../../constants/stringConstants';

export default function WhatDoYouWantToDoWithYourLease({ onRadioSelect }: { onRadioSelect }) {
  return (
    <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 'tight' }}>
      <Box css={{ gridColumnEnd: { base: 'span 12', xl: 'span 8' } }}>
        <FieldSet required legend={<Legend>What do you want to do with your lease?</Legend>}>
          <LabeledControl
            label={
              <Label>
                Update it
                <br />
                <Text css={{ color: 'text.subtle' }}>
                  Quickly make changes to your existing lease’s end date, custom rules, and/or rent.
                </Text>
              </Label>
            }
            control={
              <Radio
                name="what-do-you-want-to-do"
                value={WIZARD_SCREEN_TYPES.UPDATE_YOUR_CURRENT_TERMS_WITH_A_LEASE_RENEWAL_AGREEMENT}
                onChange={onRadioSelect}
              />
            }
          />
          <LabeledControl
            label={
              <Label>
                Replace it
                <br />
                <Text css={{ color: 'text.subtle' }}>
                  Replace the current lease with a new one — the best option for updating multiple terms.
                </Text>
              </Label>
            }
            control={
              <Radio
                name="what-do-you-want-to-do"
                value={EXTERNAL_WIZARD_OPTIONS.CREATE_LEASE}
                onChange={onRadioSelect}
              />
            }
          />
          <LabeledControl
            label={
              <Label>
                Leave it as is
                <br />
                <Text css={{ color: 'text.subtle' }}>
                  If your lease automatically converts to month-to-month when the fixed-term expires and you don’t need
                  to make any changes.
                </Text>
              </Label>
            }
            control={
              <Radio
                name="what-do-you-want-to-do"
                value={WIZARD_SCREEN_TYPES.YOUR_UPCOMING_LEASE_TERM_WILL_BE_MONTH_TO_MONTH}
                onChange={onRadioSelect}
              />
            }
          />
        </FieldSet>
      </Box>
    </Box>
  );
}
